// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getDatabase, ref, set } from "firebase/database"; // adams import
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth"

const firebaseConfig = {
    apiKey: "AIzaSyCvlPoIPf6Y_moix7cNV3w4D8yxB61JlXI",
    authDomain: "verus-amb.firebaseapp.com",
    projectId: "verus-amb",
    storageBucket: "verus-amb.appspot.com",
    messagingSenderId: "623018673141",
    appId: "1:623018673141:web:fb4e361c177b45260c16bc",
    measurementId: "G-EXRV1V09DG"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore();
const auth = getAuth()
const functions = getFunctions(app, 'northamerica-northeast1');
export { app, functions, db, auth }


